import { Injectable } from "@angular/core";

import { Title } from "@angular/platform-browser";
import { Meta } from "@angular/platform-browser";

@Injectable({
  providedIn: "root",
})
export class MetaService {
  constructor(public title: Title, public meta: Meta) {}

  updateTitle(title) {
    if (title) {
      this.title.setTitle(title);
    }
  }

  updateDescription(description: string) {
    if (description) {
      this.meta.updateTag({ name: 'description', content: description });
    }
  }
  
  updateImage(image: string) {
    if (image) {
      this.meta.updateTag({ name: 'image', content: image });
      this.meta.updateTag({ name: 'og:image', content: image });
    }
  }
  
  updateURL(url: string) {
    if (url) {
      this.meta.updateTag({ name: 'url', content: url });
      this.meta.updateTag({ name: 'og:url', content: url });
    }
  }
}
